import { MenuItemLookupResult, PortionItemType, RecentOrFavoriteEntree } from '@/models';

export function formatRecentEntreeName(entree: RecentOrFavoriteEntree, menuItemLookupMap: Map<string, MenuItemLookupResult> | null): string {
  if (!menuItemLookupMap) {
    return entree.menuItemName;
  }

  const menuLookupItem = menuItemLookupMap.get(entree.menuItemId);

  if (!menuLookupItem) {
    return entree.menuItemName;
  }

  const menuItemType = menuLookupItem.menuItemType;

  for (const content of entree.contents || []) {
    const contentLookupItem = menuItemLookupMap.get(content.menuItemId);

    if (contentLookupItem && isHalfOrExtraPortion(contentLookupItem)) {
      const secondaryFillingWords = contentLookupItem.menuItemName.split(' ');
      secondaryFillingWords.shift();

      const secondaryFilling = secondaryFillingWords.join(' ');

      if (secondaryFilling === menuLookupItem.primaryFillingName) {
        return entree.menuItemName;
      }

      return `${menuLookupItem.primaryFillingName} & ${secondaryFilling} ${menuItemType}`;
    }
  }

  return entree.menuItemName;
}

function isHalfOrExtraPortion(contentLookupItem: MenuItemLookupResult | undefined): boolean {
  if (contentLookupItem && (contentLookupItem.menuItemType === PortionItemType.HalfPortion || contentLookupItem.menuItemType === PortionItemType.ExtraPortion)) {
    return true;
  }
  return false;
}